import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Button, Form, Input, Modal, Select, Switch, message, TreeSelect } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styleModalUser.css';
import { useGroupsStore } from '../../../../store/groups/Groups';
import { Group } from '../../../../types/Group';
import { useAuthStore } from '../../../../store/auth/auth';
import { getCreateUser } from '../../../../api/users/getCreateUser';

const { Option } = Select;
interface NewGroupModalProps {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
}
const NewUserModal: React.FC<NewGroupModalProps> = ({ open, onOk, onCancel }) => {
    const { groups, fetchGroups } = useGroupsStore();
    const { user, SmartDVRToken } = useAuthStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (groups.length === 0) {
            fetchGroups();
        }
    }, [groups.length]);

    const getAllSubGroups = (group: Group): Group[] => {
        const subGroups: Group[] = [];
        group.sub_groups.forEach((subGroup) => {
            subGroups.push(subGroup);
            if (subGroup.sub_groups) {
                subGroups.push(...getAllSubGroups(subGroup));
            }
        });
        return subGroups;
    };
    const allGroups: Group[] = [];
    groups.forEach((group) => {
        allGroups.push(group);
        if (group.sub_groups) {
            allGroups.push(...getAllSubGroups(group));
        }
    });

    const convertGroupsToTreeData = useCallback((groups: Group[]): any[] => {
        return groups
            .filter((group) =>
                group.uid !== '00000000-0000-0000-0000-000000000002' &&
                group.uid !== '00000000-0000-0000-0000-000000000003' &&
                group.name !== 'Несортированные'
            )
            .map((group) => ({
                title: group.name,
                value: group.uid,
                key: group.uid,
                children: group.sub_groups ? convertGroupsToTreeData(group.sub_groups) : undefined,
            }));
    }, []);

    const treeData = useMemo(() => {
        return convertGroupsToTreeData(groups);
    }, [groups, convertGroupsToTreeData]);

    useEffect(() => {
        if (open) {
            form.setFieldsValue({
                name: '',
                login: '',
                password: '',
                isAdmin: false,
                parent_uid: ['00000000-0000-0000-0000-000000000001'],
            });
            setLoading(false);
        }
    }, [open, form]);

    const handleOk = () => {
        if (loading) return;

        setLoading(true);
        form.validateFields().then(values => {
            if (user) {
                const userData = {
                    name: values.name,
                    login: values.login,
                    password: values.password,
                    isAdmin: values.isAdmin,
                    groups: values.parent_uid || ['00000000-0000-0000-0000-000000000001'],
                };
                getCreateUser(SmartDVRToken, user.login, userData)
                    .then((response) => {
                        if (response.success) {
                            message.success('Пользователь успешно создан!');
                            onOk();
                        } else {
                            message.error(`Ошибка при создании пользователя: ${response.error.error}`);
                            setLoading(false);
                        }
                    })
                    .catch(() => {
                        message.error('Ошибка при создании пользователя');
                        setLoading(false);
                    });
            }
        }).catch(() => {
            setLoading(false);
        });
    };

    const handleCancel = () => {
        if (loading) return;
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title={
                <div className="titleModal_Group">
                    <span className="spanGroup">Добавить пользователя</span>
                    <CloseOutlined onClick={handleCancel} className="closeBut_Group" style={{ pointerEvents: loading ? 'none' : 'auto' }} />
                </div>
            }
            className="newGroup_modal"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            width={720}
            closable={false}
            confirmLoading={loading}
            maskClosable={!loading}
            keyboard={!loading}
            footer={
                <Button className="buttonAdd" onClick={handleOk} disabled={loading}>
                    Сохранить
                </Button>
            }
        >
            <Form form={form} disabled={loading}>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Имя</span>}
                    name="name"
                    required={false}
                >
                    <Input className="input_Group" />
                </Form.Item>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Группа</span>}
                    name="parent_uid"
                    required={true}
                    rules={[
                        {
                            required: true,
                            message: 'Пожалуйста, выберите группу',
                            type: 'array',
                            min: 1
                        }
                    ]}
                >
                    <TreeSelect
                        className="selectGroup"
                        placeholder="Введите название или выберите из списка"
                        treeData={treeData}
                        showSearch
                        allowClear={false}
                        multiple={true}
                        treeDefaultExpandAll
                        filterTreeNode={(inputValue, treeNode) => {
                            const title = String(treeNode.title || '');
                            return title.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        treeNodeFilterProp="title"
                    />
                </Form.Item>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Логин</span>}
                    name="login"
                    required={false}
                >
                    <Input className="input_Group" />
                </Form.Item>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Администратор</span>}
                    name="isAdmin"
                    valuePropName="checked"
                    required={false}
                >
                    <Switch />
                </Form.Item>
                <Form.Item
                    className="form_Group"
                    label={<span className="inputLabel_Group">Пароль</span>}
                    name="password"
                    required={false}
                >
                    <Input className="input_Group" />
                </Form.Item>
            </Form>
        </Modal>
    );
};
export default NewUserModal;
